import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import unregister from './registerServiceWorker';
// import '@grapecity/ar-viewer/dist/jsViewer.min.js';
// import '@grapecity/ar-viewer/dist/jsViewer.min.css';
import {ColorModeScript} from '@chakra-ui/react';
import {Routes, Route, BrowserRouter} from 'react-router-dom';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

if (process.env.NODE_ENV !== 'development') console.log = () => {};

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter basename={baseUrl}>
      <ColorModeScript />
      <Routes>
        <Route path="/*" element={<App />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
  rootElement
);

unregister();
